import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';

// import { Geolocation } from '@ionic-native/geolocation/ngx';
// import {
//   NativeGeocoder,
//   NativeGeocoderOptions,
//   NativeGeocoderResult,
// } from '@ionic-native/native-geocoder/ngx';
// import { Platform } from '@ionic/angular';
declare var google;
@Component({
  selector: 'app-business-location',
  templateUrl: './business-location.page.html',
  styleUrls: ['./business-location.page.scss'],
})
export class BusinessLocationPage implements OnInit {
  @ViewChild('map') mapElement: ElementRef;
  longitude: number;
  latitude: number;
  map: any;
  geocoder = new google.maps.Geocoder();
  business_name: any;
  constructor() {
  }

  ngOnInit() {
    
  }
  ionViewWillEnter() {
    console.log('view Entered');
    // this.getbusinessLocation();

  
  }

  // getbusinessLocation() {
  //   this.storage.get('resData').then((resInfo) => {
  //     this.business_name = resInfo.name;
  //     let long = parseFloat(resInfo.longitude);
  //     let lat = parseFloat(resInfo.latitude);
  //     this.longitude=long;
  //     this.latitude=lat;
  //     // console.log('info', resInfo);
  //     console.log('Lat', this.longitude);
  //     console.log('Long',  this.latitude);
  //     //converting to address
  //   //   const pos = {
  //   //     lat: this.latitude,
  //   //     lng: this.longitude,
  //   //   }
  //   //   this.geocoder.geocode({
  //   //     'latLng': pos
  //   // }, (results, status)=> {
  //   //   console.log(results[4].formatted_address);

      
  //   //   console.log(status)
        
  //   // });
  //     this.loadMap();

  //   });
    
  // }

  loadMap() {
    console.log(this.mapElement);
   
    let mapOptions = {
      center: {
        lat: this.latitude,
        lng: this.longitude
      },
      zoom: 10,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
    };
    console.log(this.latitude, this.longitude);
    this.map = new google.maps.Map(this.mapElement.nativeElement, mapOptions);
    //  this.addMarker(position.coords.latitude,position.coords.longitude);
    this.addMarker(this.latitude, this.longitude);
  }

  addMarker(lat: number, lng: number) {
    console.log('Marker Cords',lat,lng);
    let latLng = new google.maps.LatLng(lat, lng);
    let marker = new google.maps.Marker({
      map: this.map,
      animation: google.maps.Animation.DROP,
      position: latLng,
    });

    let content = this.business_name;

    this.addInfoWindow(marker, content);
  }
  addInfoWindow(marker, content) {
    let infoWindow = new google.maps.InfoWindow({
      content: content,
    });

    google.maps.event.addListener(marker, 'click', () => {
      infoWindow.open(this.map, marker);
    });
  }
}
